import list from './list'
import playback from './playback'

const calendar = {
  path: 'calendar',
  component: resolve => require(['../../../../pages/user/course/calendar'], resolve),
  redirect: 'calendar/list',
  children: [
    list,
    playback
  ]
}

export default calendar



// WEBPACK FOOTER //
// ./src/router/user/course/calendar/index.js